module.exports = __webpack_public_path__ + "img/pr-6.ef446c11.png";